"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CloseOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M18.7 6.7a1 1 0 00-1.4-1.4L12 10.58l-5.3-5.3a1 1 0 00-1.4 1.42L10.58 12l-5.3 5.3a1 1 0 101.42 1.4L12 13.42l5.3 5.3a1 1 0 001.4-1.42L13.42 12l5.3-5.3z" } }] }, "name": "close", "theme": "outlined" };
exports.default = CloseOutlined;
